import { AppKeys } from '../../../core/localization';

export * from './const';
export * from './model';
export * from './defaults';
export * from './actions';
export * from './utils';

export enum HistoryEventDto {
  DeviceCreated,
  DeviceActivated,
  DeviceDeactivated,
  KeyRetrievedByMdmClient,
  KeyRetrievedByKemFile,
  KeyRetrievedByOmsFile,
  RegistrationSuccess,
  RegistrationFailed,
  OwnershipManuallyAllocated,
  OwnershipManuallyUnallocated,
  KeyRetrievedByXmlFile,
  KeyRetrievedByPackIt,
  SigFoxInfoRetrievedByFile,
  ReadAccessAssigned,
  ReadAccessRemoved,
  TransferDeviceSent,
  TransferDeviceReceived,
  TransferDeviceRequest,
  TransferDeviceAccept,
  KeyRetrievedByElsService,
  KeyRetrievedByKem2File

}

export const HistoryEventTKeys = Object.freeze({
  [HistoryEventDto.DeviceCreated]: AppKeys.Device_History_Event_DeviceCreated,
  [HistoryEventDto.DeviceActivated]:
    AppKeys.Device_History_Event_DeviceActivated,
  [HistoryEventDto.DeviceDeactivated]:
    AppKeys.Device_History_Event_DeviceDeactivated,
  [HistoryEventDto.KeyRetrievedByMdmClient]:
    AppKeys.Device_History_Event_KeyRetrievedByMdmClient,
  [HistoryEventDto.KeyRetrievedByKemFile]:
    AppKeys.Device_History_Event_KeyRetrievedByKemFile,
  [HistoryEventDto.KeyRetrievedByKem2File]:
    AppKeys.Device_History_Event_KeyRetrievedByKem2File,
  [HistoryEventDto.KeyRetrievedByOmsFile]:
    AppKeys.Device_History_Event_KeyRetrievedByOmsFile,
  [HistoryEventDto.RegistrationSuccess]:
    AppKeys.Device_History_Event_RegistrationSuccess,
  [HistoryEventDto.RegistrationFailed]:
    AppKeys.Device_History_Event_RegistrationFailed,
  [HistoryEventDto.OwnershipManuallyAllocated]:
    AppKeys.Device_History_Event_OwnershipManuallyAllocated,
  [HistoryEventDto.OwnershipManuallyUnallocated]:
    AppKeys.Device_History_Event_OwnershipManuallyUnallocated,
  [HistoryEventDto.KeyRetrievedByXmlFile]:
    AppKeys.Device_History_Event_KeyRetrievedByXmlFile,
  [HistoryEventDto.KeyRetrievedByPackIt]:
    AppKeys.Device_History_Event_KeyRetrievedByPackIt,
  [HistoryEventDto.SigFoxInfoRetrievedByFile]:
    AppKeys.Device_History_Event_SigFoxInfoRetrievedByFile,
  [HistoryEventDto.ReadAccessAssigned]:
    AppKeys.Device_History_Event_ReadAccessAssigned,
  [HistoryEventDto.ReadAccessRemoved]:
    AppKeys.Device_History_Event_ReadAccessRemoved,
    [HistoryEventDto.TransferDeviceSent]:
    AppKeys.Device_History_Event_TransferDeviceSent,
    [HistoryEventDto.TransferDeviceReceived]:
    AppKeys.Device_History_Event_TransferDeviceReceived,
    [HistoryEventDto.TransferDeviceRequest]:
    AppKeys.Device_History_Event_TransferDeviceRequest,
    [HistoryEventDto.TransferDeviceAccept]:
    AppKeys.Device_History_Event_TransferDeviceAccept,
    [HistoryEventDto.KeyRetrievedByElsService]:
    AppKeys.Device_History_Event_KeyRetrievedByElsService,
});
